import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Tooltip, IconButton, Box, Typography } from "@mui/material";
import DeleteRow from "../../components/DeleteRow";
import Detail from "../../main/detail/Detail";
import { useNavigate, useLocation } from "react-router-dom";
import { UseFAQ } from "./UseFAQ";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function EditFAQ() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { getFAQDataListById, deleteFAQ } = UseFAQ();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [comRes, setComRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getFAQDataListById(location.state.id, (faQs) => {
        setComRes(faQs);
      });
    }
  }, []);

  const newFunc = () => {
    return navigate("/faq/addfaq", {
      state: {
        id: location.state.id,
        FAQsRes: comRes.faQs,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      headerName: "ردیف",
      align: "center",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      headerName: "ردیف",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "question",
      headerName: " سوال ",
      headerAlign: "center",
      width: 850,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.question
              .replace(/(<([^>]+)>)/gi, "")
              .replace(/(&nbsp;)/gi, " ")}
          </Typography>
        );
      },
    },
    {
      field: "answer",
      headerName: "پاسخ",
      hide: true,
      width: 220,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.answer}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      headerName: "عملیات",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/faq/editfaq/editfaqrow", {
                    state: {
                      model: cellValues.row,
                      id: cellValues.row.id,
                      pID: location.state.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/faq" },
          { name: "ویرایش سوالات متداول", url: "/faq/editfaq" },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ flexGrow: 1 }}>
          {comRes ? (
            <DataGrid
              className="ltr-grid"
              columns={columns}
              rows={comRes.faQs}
              enableRangeSelection={true}
              disableColumnMenu
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: { newFunc: newFunc, isLtr: true },
              }}
              hideFooterSelectedRowCount
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
          <DeleteRow
            deleteState={deleteState}
            setDeleteState={setDeleteState}
            type={"سوال"}
            callback={() => {
              setProgress(true);
              deleteFAQ(deleteState.id, () => {
                getFAQDataListById(location.state.id, (faQs) => {
                  setComRes(faQs);
                });
              });
            }}
          ></DeleteRow>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/faq", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
